import { message } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { constants } from "../../../constants/constants";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import {
  deleteMobilePage,
  getMobilePage,
  updateMobilePage,
} from "../../../utils/ApiCalls/AddMobilePage";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import YouTubeEmbed from "../../Banner/YouTubeEmbed";
import CustomHeaderTitle from "../../constants/CustomHeaderTitle";
import HeaderBread from "../../HeaderBread";
import Logs from "../../Logs";
import CustomizedTable from "../../UI/CustomizedTable";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

export const CustomChoseList = ({ category, type }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState();
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [active, setActive] = useState("listing");
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [sort, setSort] = useState("");
  const [vesselOptions, setVesselOptions] = useState([]);
  const [order, setOrder] = useState("");
  const [columns, setColumns] = useState([]);
  const [navigation, setNavigation] = useState([]);

  useEffect(() => {
    getOptionLocation();
  }, []);
  useEffect(() => {
    if (category?.id)
      setNavigation([
        {
          title: "Home",
          route: "/",
        },
        {
          title: "Mobile App Shore CMS",
          route: "/",
        },
        {
          title: "All Pages",
          route: "/ship/all-pages/genting-dream/" + category.id,
        },
        {
          title: vesselOptions.find((item) => item.id == category?.vessel_id)
            ?.name,
          route: "/shore/all-pages/genting-dream/" + category.id,
        },
        {
          title: category?.name,
          route: "/shore/all-pages/genting-dream/" + category.id,
        },
      ]);
  }, [vesselOptions, category]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleDelete = async (id, url) => {
    if (true || checkPermission(permission, "delete_per", "ships",window?.location?.pathname)) {
      await deleteMobilePage(id);
      // await deleteMenuList({ url });
      addlog("Mobile page Deleted", category?.name, { id }, userDetails.id);
      getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };

  const handleUpdate = async (id, values, title, location_id) => {
    if (true || checkPermission(permission, "update_per", "Categories",window?.location?.pathname)) {
      let data = await updateMobilePage(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Categories " +
            (!values.valid_from
              ? values.is_active === 1
                 ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Categories",
          { ...values, id, title },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };

  useEffect(() => {
    setColumns([
      {
        title: "No",
        width: 10,
        dataIndex: "id",
        key: "position",
        fixed: "left",
       render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Title/Venue",
        width: 10,
        dataIndex: "Title",
        key: "title",
        fixed: "left",
        render: (item, record) => (
          <render>{item || record?.venue?.name}</render>
        ),
      },
      {
        title: "Parent Category",
        width: 10,
        dataIndex: "slug",
        key: "slug",
        fixed: "left",
        render: (item, record) => <render>{category?.name}</render>,
      },
      {
        title: "Sub Category",
        width: 10,
        dataIndex: "slug",
        key: "slug",
        fixed: "left",
        render: (item, record) => (
          <render>{record?.child_category?.name}</render>
        ),
      },
      {
        title: "Image",
        width: 30,
        dataIndex: "image",
        key: "image",
        render: (image, record) => {
          if (record.content_type === "video") {
            return (
              <video
                src={`${constants.MEDIAURL}/${image}`}
                style={{ width: "100px", height: "80px" }}
              >
                <track kind="captions" src="" label="English captions" />
              </video>
            );
          } else if (record.content_type === "link") {
            return (
              <YouTubeEmbed
                videoUrl={`${constants.MEDIAURL}/${image}`}
                width="100px"
                height="80px"
              />
            );
          } else {
            return (
              <img
                alt="banner"
                src={`${constants.MEDIAURL}/${image}`}
                style={{ width: "100px", height: "80px" }}
              />
            );
          }
        },
      },

      {
        title: "Action",
        key: "operation",
        width: 30,
        render: (text, record) => (
          <div className="table_action_btn">
            <Link
              to={
                "/ship/all-pages/" +
                vesselOptions
                  .find((item) => item.id == category?.vessel_id)
                  ?.name?.replaceAll(" ", "-")
                  ?.toLowerCase() +
                "/" +
                +category.id +
                "/" +
                record.id +
                "/add"
              }
            >
              <button className="btn">
                <i
                  className="ri-edit-2-line"
                  data-toggle="tooltip"
                  title="Edit"
                ></i>
              </button>
            </Link>
          </div>
        ),
      },
    ]);
  }, [page, pageSize, search, category]);

  const getData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getMobilePage({ catergory_id: category?.id });
    setRows(data.data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    if (category?.id) getData();
  }, [category]);

  return (
    <Layout type={"read_per"} module_data={"ships"}>
      <CustomHeaderTitle title={"Deals"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={category?.name}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">All {category?.name} List</h5>
                </div>

                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    ></div>
                    {rows && (
                      <CustomizedTable
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        title={"Cabin Category"}
                        sortHandler={() => {}}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>{" "}
        {active === "logs" && (
          <Logs
            type={"Page"}
            slug={"/website/webpages/our-ship/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};
